<template>
  <div class="accordion">
    <div class="accordion__wrapper" @click="reemitClickEvent">
      <div class="accordion__title" :class="{'accordion__title--hover' : icon}" aria-hidden="true">
        <div v-if="!icon" class="accordion__icon">
          <font-awesome-icon v-if="isOpened" icon="minus" />
          <font-awesome-icon v-else icon="plus" />
        </div>
        <div v-else class="accordion__icon accordion__icon--custom" aria-hidden="true">
          <img :src="customIcon" alt="null" aria-hidden="true">
        </div>
        <span>
          {{ title }}
        </span>
      </div>
      <div v-if="subtitle && !innerSubtitle" class="accordion__subtitle">
        {{ subtitle }}
      </div>
    </div>
    <div ref="content" class="accordion__content">
      <div v-if="subtitle && innerSubtitle" class="accordion__subtitle accordion__subtitle--inner">
        {{ subtitle }}
      </div>
      <p v-for="paragraph in text">
        {{ paragraph }}
      </p>
    </div>
  </div>
</template>
<script>
import uniqueId from 'lodash.uniqueid'

export default {
  name: 'Accordion',
  data () {
    return {
      isOpened: false,
      contentHeight: undefined,
      customIcon: undefined,
      id: undefined
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    text: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      validator: value => ['rocket', 'stopwatch', 'bulb', 'hammer', 'floater'].includes(value)
    },
    innerSubtitle: Boolean
  },
  methods: {
    reemitClickEvent () {
      this.$emit('click', this.$vnode.child)
    }
  },
  watch: {
    isOpened (isOpen) {
      if (isOpen) this.$refs['content'].style.height = this.contentHeight + 'px'
      else this.$refs['content'].style.height = '0'
    }
  },
  async created () {
    if (this.icon) {
      this.customIcon = (await import(`@/assets/images/icons/${this.icon}.svg`)).default
    }
  },
  mounted () {
    this.id = uniqueId()
    this.contentHeight = this.$refs['content'].getBoundingClientRect().height
    this.$refs['content'].style.height = '0'
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.accordion
  @apply inline-block
  @screen md
    @apply w-80
  @screen lg
    @apply w-144
  &__wrapper
    @apply inline-flex flex-col cursor-pointer mb-2
  &__title
    @apply inline-flex items-center text-xl font-thin uppercase
    @screen xl
      @appl text-3xl
    &--hover
      &:hover
        @apply text-pink
  &__subtitle
    @apply text-pink
    margin-top: .3rem
    &--inner
      @apply mt-0 mb-2
  &__icon
    @apply inline-flex justify-center items-center text-white text-lg bg-pink rounded-full w-6 h-6
    margin-right: .6rem
    &--custom
      @apply bg-transparent w-7 h-7
  &__content
    @apply overflow-hidden
    transition: height .4s
    p
      &:not(:first-child)
        @apply mt-2
    p:last-child
      @apply mb-2
</style>
